{
    "ClientConfiguration_Table_Headers_Description": "Descrição",
    "ClientConfiguration_Table_Headers_TelSys": "Servidor de Telefonia",
    "ClientConfiguration_Table_Headers_Partition": "Partição",
    "ClientConfiguration_Table_Headers_Device": "Dispositivo",
    "ClientConfiguration_Footer_Add": "Adicionar",
    "ClientConfiguration_Footer_View": "Visualizar",
    "ClientConfiguration_Footer_Change": "alterar",
    "ClientConfiguration_Footer_Delete": "remover",
    "ClientConfiguration_Footer_Selected": "{} Selecionado",
    "ClientConfiguration_Footer_NoRows": "Não há nada para ver aqui...",
    "ClientConfiguration_No_Available_CMEs": "não tem CMEs com as capacidades necessárias",
    "NAME": "ClientConfigurationLanguage",
    "ClientConfiguration_Table_Headers_CME": "Servidor de Telefonia",
    "ClientConfiguration_Admin_Filters_CME": "CME",
    "ClientConfiguration_Admin_Filters_IncludeChildCMEs": "Incluir CME Filho",
    "ClientConfiguration_Admin_Filters_Search": "Procurar"
}